import { Box, FormControlLabel, Switch, Typography } from '@mui/material'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import ConfirmAction from 'src/v3/components/confirm-action'
import {
  selectSelectedLinkedService,
  errorMessageChanged,
  selectLinkedServiceById,
  fetchLinkedServices,
} from '../admin.slice'

export default ({
  setFormOpen,
  formOpen,
}: {
  setFormOpen: (arg: string) => void
  formOpen: string
}) => {
  let dispatch = useAppDispatch()
  let selectedLinkedService = useAppSelector(selectSelectedLinkedService)
  let linkedService = useAppSelector(
    selectLinkedServiceById(selectedLinkedService),
  )

  let onNREMTVerificationChanged = () =>
    axios
      .put('/api/v2/admin/linked-service/nremt-verification', {
        id: selectedLinkedService,
        nremtVerification:
          linkedService?.nremtVerification === 'full' ? 'disabled' : 'full',
      })
      .then(() => dispatch(fetchLinkedServices()))
      .catch((err) => {
        dispatch(
          errorMessageChanged(
            err?.message || 'Error Changing NREMT Verification Status',
          ),
        )
        dispatch(fetchLinkedServices())
      })

  return (
    <Box className="w-full">
      <Box className="flex items-center" sx={{ minHeight: '50px' }}>
        <FormControlLabel
          label={
            <Typography
              variant="body2"
              sx={{ fontWeight: 600 }}
              color="textSecondary"
            >
              NREMT Verification
            </Typography>
          }
          control={
            <Switch
              checked={linkedService?.nremtVerification === 'full'}
              onChange={() => setFormOpen('nremt-verification')}
              color={
                linkedService?.nremtVerification === 'full'
                  ? 'primary'
                  : 'default'
              }
            />
          }
        />
      </Box>

      <ConfirmAction
        executeAction={onNREMTVerificationChanged}
        open={formOpen}
        setOpen={setFormOpen}
        openText="nremt-verification"
        title="Confirm Status Change"
        text={`Are you sure you want to ${
          linkedService?.nremtVerification === 'full' ? 'disable' : 'enable'
        } NREMT verification for ${linkedService?.name}?`}
        onFailure={(err) =>
          dispatch(
            errorMessageChanged(
              `Error Updating NREMT Verification for ${linkedService?.name || 'Linked Service'}: ${err}`,
            ),
          )
        }
      />
    </Box>
  )
}
